import { Box, TextField, IconButton, InputAdornment, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const MAX_QUESTION_LENGTH = 150;

const QuestionInput = ({
  value,
  onChange,
  onClear,
  onSubmit,
  disabled = false,
  endAdornment,
  placeholder = 'Ask anything, in any language.',
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (onSubmit) {
        onSubmit();
      } else {
        const form = e.target.closest('form');
        if (form) form.requestSubmit();
      }
    }
  };

  const handleChange = (e) => {
    onChange(e.target.value.slice(0, MAX_QUESTION_LENGTH));
  };

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <TextField
        placeholder={placeholder}
        fullWidth
        variant="outlined"
        multiline
        minRows={2}
        maxRows={3}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 3,
            bgcolor: 'background.paper',
            fontSize: '1rem',
            alignItems: 'flex-end',
            '& fieldset': {
              borderColor: 'rgba(106, 27, 109, 0.3)',
            },
            '&:hover fieldset': {
              borderColor: 'primary.light',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
              borderWidth: 1.5,
            },
          },
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end" sx={{ alignSelf: 'flex-end', mb: 1 }}>
                {value?.length > 0 && (
                  <IconButton size="small" onClick={onClear} disabled={disabled}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
                {endAdornment}
              </InputAdornment>
            ),
          },
        }}
      />
      {/* Character counter - subtle, inside bottom-right */}
      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          right: 12,
          bottom: 6,
          color: value?.length >= MAX_QUESTION_LENGTH ? 'error.main' : 'text.disabled',
          fontSize: '0.65rem',
          pointerEvents: 'none',
        }}
      >
        {value?.length || 0}/{MAX_QUESTION_LENGTH}
      </Typography>
    </Box>
  );
};

export default QuestionInput;
